<app-ace-select [formControl]="control"
                [appendTo]="appendTo"
                [multiSelect]="multiSelect"
                [closeOnSelect]="!multiSelect"
                [loading]="loading"
                [items]="templates"
                [bindValue]="bindValue"
                [placeholder]="placeholder | messageTranslate"
                [isReadOnly]="isReadOnly"
                [searchFn]="searchTemplate"
                [showItemsWhileLoading]="showItemsWhileLoading"
                [clearable]="clearable"
                (blur)="onBlur()"
                (openEvent)="onOpen()"
                (closeEvent)="onClose()">

  <ng-template #optionTemplate let-template="item">
    <div class="text-truncate" [ngStyle]="{'width': dropdownWidth}">
      <span class="fw-bold">{{ template['template_name']}}</span>
      <small [title]="template['properties'].rule_name">- {{ template['properties'].rule_name }}</small>
    </div>

    @if (template.sensorMetadata?.length) {
      <div class="ms-1 border-top" [ngStyle]="{'width': dropdownWidth}">
        <div class="row">
          @for (metadata of template.sensorMetadata; track metadata) {
            <small class="col-6 text-truncate" [title]="metadata">
              {{metadata}}
            </small>
          }
        </div>
      </div>
    }
  </ng-template>

  <ng-template #labelTemplate let-template="item">
    {{ template.template_name }}
  </ng-template>

  <ng-template #multiLabelTemplate let-templates="items" let-clear="clear">
    @if (selectedTemplatesDisplayMax == null || templates.length <= selectedTemplatesDisplayMax) {
      @for (template of templates; track template.template_id) {
        <div class="ng-value d-flex align-items-center text-wrap">
          <span class="ng-value-icon" aria-hidden="true" (click)="clear(template)">&times;</span>
          <!-- Ensure tooltipById.get() is only called with a valid key. Prevents TypeScript errors from evaluating .get(undefined) -->
          <span class="ng-value-label"
                [attr.title]="(tooltipById && template?.template_id != null)
                  ? (tooltipById.get(template.template_id) | messageTranslate)
                  : undefined">{{template.template_name}}</span>
        </div>
      }
    } @else {
      <div class="ng-value">
        <span class="ng-value-label">{{ 'count templates selected' | messageTranslate:{count: templates.length} }}</span>
      </div>
    }
  </ng-template>

</app-ace-select>

@let templateIdForViewTemplateLink = showViewTemplateLink && !multiSelect && getSingleTemplateId();
@if (templateIdForViewTemplateLink) {
  <div class="mt-2">
    <a target="_blank"
       rel="opener"
       class="small"
       [title]="'View Template' | messageTranslate"
       [routerLink]="['/rules', 'editor' , 'view', templateIdForViewTemplateLink]">
      {{ 'View Template' | messageTranslate }}
    </a>
  </div>
}